import theme from '../../../lib/theme';

const {
  corners,
  scale,
  colors,
  font: {
    heights,
    families,
    spacings,

    ...font
  },
} = theme;

export default () => ({
  imageContainer: {
    position: 'relative',
    paddingBottom: '56.25%',
    overflowY: 'hidden',
  },

  image: {
    position: 'absolute',
    top: 0,
    width: '100%',
    borderRadius: corners.m,
    backgroundColor: colors.grey,
  },

  caption: {
    padding: `${scale.xxs} 0`,
    color: colors.black,
    fontSize: font.s,
    fontFamily: families.copy,
    lineHeights: heights.s,
    letterSpacing: spacings.m,

    '> a': {
      textDecoration: 'underline',
    },
  },
});
